/**
 * @description
 * @author librajt
 * @date
 */

import React, { Component } from 'react';
import { IUserMedal } from '@umu/umu-types';
import { components } from 'common';
const { PreImg } = components;

import { getMedalIcon, MEDAL_SIZE } from '../../../@utils/userAchievementUtil';
import { transformPx2Rem } from '../../../@utils';
import './userMedalIcon.scss';

interface IUserMedalIconProps {
    userMedalInfo?: IUserMedal;
    userMedalWidth: 20 | 30 | 16 | 12;
}

export default class UserMedalIcon extends Component<IUserMedalIconProps, {}> {
    public render() {
        let size;
        const { userMedalWidth } = this.props;
        if (userMedalWidth) {
            size = {
                width: transformPx2Rem(userMedalWidth + 'px'),
                height: transformPx2Rem(userMedalWidth + 'px'),
            };
        }

        const { userMedalInfo } = this.props;
        if (!userMedalInfo) {
            return null;
        }

        const medalIcon = getMedalIcon(userMedalInfo.medal_type, userMedalInfo.medal_rank, MEDAL_SIZE.SMALL);
        return (
            <div className="user-medal-icon">
                <div className="user-medal" style={size}>
                    <div className="img">
                        <PreImg>
                            <img src={medalIcon} alt="" />
                        </PreImg>
                    </div>
                </div>
            </div>
        );
    }
}
